// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo__1yHj5","sider":"index_sider__3ZiHK","fixSiderbar":"index_fixSiderbar__2_ofI","light":"index_light__eNWll","icon":"index_icon__2C7OK"};